module.exports = __webpack_public_path__ + "media/חתול.706c25fb.mp3";